import gql from 'graphql-tag'

const DELETE_CLIENTS = gql`
    mutation deleteClients ($orgId: ID!, $ids: [ID]) {
        deleteClients(orgId: $orgId, ids: $ids)
    }
`
export default DELETE_CLIENTS
